export const FETCH_SELECTED_USER_PENDING = 'FETCH_SELECTED_USER_PENDING';
export const FETCH_SELECTED_USER_SUCCESS = 'FETCH_SELECTED_USER_SUCCESS';
export const FETCH_SELECTED_USER_ERROR = 'FETCH_SELECTED_USER_ERROR';
